import getKey from '@/clir/utils/getKey';

export const auth = async ({ to, next, store }) => {
    if (store.getters['error/isError'] || getKey(to, 'meta.middleware.auth', false) === false) return next();
    try {
        await store.dispatch('user/getMe');
        return next();
    } catch (e) {
        await store.dispatch('user/reset');
        await store.dispatch('error/notAuthenticated');
        return next();
    }
};

export default { auth };
